import { render, staticRenderFns } from "./TemplateUploadCover.vue?vue&type=template&id=1da5905f&scoped=true&"
import script from "./TemplateUploadCover.vue?vue&type=script&lang=js&"
export * from "./TemplateUploadCover.vue?vue&type=script&lang=js&"
import style0 from "./TemplateUploadCover.vue?vue&type=style&index=0&id=1da5905f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5905f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
